/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 02/06/2020
 *
 */

import React from 'react';
import './card.css';

/** functional component for CardIconContainer **/
const CardIconContainer = (props) => {
    const {children, color, ...rest} = props;

    let cardColor;

    switch (color) {
        case 'red':
            cardColor = 'linear-gradient(60deg, #ef5350, #e53935)';
            break;
        case 'yellow':
            cardColor = 'linear-gradient(60deg, #ffa726, #fb8c00)';
            break;
        case 'blue':
            cardColor = 'linear-gradient(60deg, #26c6da, #00acc1)';
            break;
        default:
            cardColor = 'linear-gradient(60deg, #66bb6a, #43a047)'
    }
    return (
        <div className="cardIconContainer" style={{background: cardColor}} {...rest}>
            {children}
        </div>
    )
};

export default CardIconContainer;
